import $ from 'jquery';

/**
   * show the quality score detail in the dialog next to it
   *
   * @param {Object} event - The backbone click event from where the quality score cell was clicked.
   * @param {Object} qualityScore - The qualityscore detailed object.
   * @param {String} qsContainerId - The container id to show the quality score detail info.
   * @param {Object} legacyGlobalI18n - Legacy global i18n
   * @returns {undefined}.
   */
export function showQualityScoreDetail(event, qualityScore, qsContainerId, legacyGlobalI18n) {
  const {
    KeywordRelevance,
    LandingPageQuality,
    LandingPageRelevance,
    OverallQualityScore,
  } = qualityScore || {};

  $.gridPopup.clickEvent(
    event, () => {
      $.advertiser.controls.qualityscore.DisplayQsFlyout( // eslint-disable-line new-cap
        KeywordRelevance || 0,
        LandingPageQuality || 0,
        LandingPageRelevance || 0,
        OverallQualityScore || 0
      );
    },
    qsContainerId,
    `${legacyGlobalI18n.getString('QualityScoreFlyOut_TotalScoreHeading')} ${OverallQualityScore} ${legacyGlobalI18n.getString('QualityScoreFlyOut_TotalScore')}`
  );
}
